import React, { createContext, useCallback, useMemo, useState } from 'react';

export const NotificationsUIContext = createContext();

export const useNotificationsUIContext = () => React.useContext(NotificationsUIContext);

export const NotificationsUIProvider = ({ children, isIframe = false }) => {
  const [openedPopups, setOpenedPopups] = useState([]);
  const [isBetslipOpen, setIsBetslipOpen] = useState(false);
  const [isFlyingBetslip, setIsFlyingBetslip] = useState(false);
  const [isQuickBet, setIsQuickBet] = useState(false);

  const emitPopupToggle = useCallback(popupId => {
    setOpenedPopups(prevState =>
      prevState.includes(popupId) ? prevState.filter(p => p !== popupId) : [...prevState, popupId],
    );
  }, []);

  const emitBetslipToggle = useCallback(state => {
    setIsBetslipOpen(state);
  }, []);

  const value = useMemo(() => ({
      emitBetslipToggle,
      emitPopupToggle,
      isBetslipOpen,
      isFlyingBetslip,
      isIframe,
      isPopupOpen: openedPopups.length > 0,
      isQuickBet,
      setIsFlyingBetslip,
      setIsQuickBet,
    }),
    [
      emitBetslipToggle,
      emitPopupToggle,
      isBetslipOpen,
      isFlyingBetslip,
      isIframe,
      isQuickBet,
      openedPopups.length,
    ],
  );

  return (
    <NotificationsUIContext.Provider value={value}>{children}</NotificationsUIContext.Provider>
  );
};
